import React from 'react';

export default function NoRoleComponent() {
  return (
    <div>
      <h6>You don't have any roles assigned in this app.</h6>
      <h6>Please contact admin for more details.</h6>
    </div>
  );
}
